import {
  RESIZE_SCREEN,
  SET_ORIENTATION
} from 'shared/actions/types';

const initialState = {
  dimensions: {
    width: 0,
    height: 0,
  },
  orientation: null
};

export default function(state = initialState, action){
  switch(action.type) {
    case RESIZE_SCREEN:
      //print("from storyReducer, payload: ", action.payload);
      return {
        ...state,
        dimensions: {
          width: action.payload.width,
          height: action.payload.height,
        }
      };

    case SET_ORIENTATION:
      return {
        ...state,
        orientation: action.payload
      };

    default:
       return state;
  }
}
